<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modalcitows">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b> Enviar mensaje por WhatsApp </b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <p class="mb-0"> <b>Nombres:</b> {{obj.estudent.nombres}} {{obj.estudent.pri_apellido}} </p> 
              <p class=""> <b>Celular:</b> {{obj.tel}} </p> 
              <p class="mb-0 blue--text"> Puede editar el texto a continuacion para enviarlo por whatsapp </p> 
              <textarea class="form-control" cols="30" rows="10" v-model.trim="obj.texto"></textarea>
            </div>

            <div class="modal-footer">
                <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Enviar por WhatsApp </button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            obj:{ // {xid:Number,xtitle:String,xbody:String,xsql:Object}
                type: Object,
                required: true
            },
        },
        data(){
            return{
                activo: true,
            }
        },
        watch:{

        },
        components:{},
        methods:{
           submit(){
            window.open(`${process.env.VUE_APP_API_WHATSAPP}` + this.obj.tel + '&text=' + this.obj.texto);
           }
        },
    
    }
</script>